


// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
export namespace Models {
	/**
	 * To improve build and incremental build times we transpile modules using TS transpileOnly mode. It essentially builds one file at a time
	 * Using transpileOnly with emitDecoratorMetadata flag sometimes causes issues when a type or an interface is used as a property type on a decorated property
	 * Example typescript:
	 * import {Models} from '../ags-generated';
	 * import AgsViewModel = Models.AgsViewModel;
	 * export class AgsStore {
	 *   @observable model: AgsViewModel;
	 * }
	 * Generated javascript:
	 * var ags_generated_1 = __webpack_require__(<webpackModuleId>);
	 * var AgsViewModel = ags_generated_1.Models.AgsViewModel;
	 * the previous line will result in runtime error if Models does not export anything
	 * In order to avoid runtime errors accessing undefined Models let's export dummy variable
	 */
	export const __dummy = true;
	export interface LoginPageClientSideTestData {
		InitialErrorMessage: UserMessage;
		ShowTxtSentBanner: boolean;
	}
	export interface UserMessage {
		IsSafeHtml: boolean;
		Message: string;
	}
	export enum LoginView {
		NotSpecified = 0, AdminEmailAndPassword = 1, PayerMobile = 2, PayerMobileCode = 3, PayerEmailAndPassword = 4, Signpost = 5,
	}
	export interface LoginResultModel {
		RedirectTo: string;
		Success: boolean;
		ErrorMessage: UserMessage;
	}
	export interface PasswordlessResendCodeResultModel {
		Token: string;
		Result: PasswordlessMobileLoginResult;
	}
	export enum PasswordlessMobileLoginResult {
		UnspecifiedError = 0, UnverifiedPhoneNumber = 1, ConfirmationCodeSent = 2, PhoneNumberInvalidFormat = 3, TooManyFailedAttempts = 4, UnknownPhoneNumber = 6, SmsFailedToSend = 7, Throttled = 9,
	}
	export interface PasswordlessMobileLoginResultModel {
		Token: string;
		ErrorMessage: UserMessage;
		Mobile: PasswordlessMobileNumber;
		Result: PasswordlessMobileLoginResult;
	}
	export interface PasswordlessMobileNumber {
		NormalisedInternationalNumber: string;
		NationalNumber: string;
	}
	export interface PasswordlessCodeVerificationResultModel {
		RedirectTo: string;
		Result: PasswordlessCodeVerificationResult;
		ErrorMessage: UserMessage;
		UserName: string;
	}
	export enum PasswordlessCodeVerificationResult {
		LoggedIn = 0, CodeConfirmationFailed = 1, EmailAndPasswordAuthenticationRequired = 2, MobileNumberIsSuspicious = 3,
	}
}
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
